export default __webpack_public_path__ + "static/media/applicant-note.7a30e3ab.svg";